import * as React from "react";
const SvgComment = () => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.25 11.2c0-4.562 4.51-7.95 9.75-7.95s9.75 3.388 9.75 7.95c0 1.88-.82 3.563-2.09 4.909l.448 3.803a.75.75 0 0 1-1.021.785l-4.594-1.827c-.822.211-1.636.28-2.493.28-5.24 0-9.75-3.388-9.75-7.95M12 4.75c-4.742 0-8.25 3.012-8.25 6.45s3.508 6.45 8.25 6.45c.855 0 1.597-.076 2.325-.29a.75.75 0 0 1 .489.023l3.657 1.455-.343-2.91a.75.75 0 0 1 .22-.624c1.2-1.173 1.902-2.59 1.902-4.104 0-3.438-3.508-6.45-8.25-6.45",
    clipRule: "evenodd"
  }
));
export default SvgComment;
